import styled from 'styled-components';
import { SearchLineIcon } from '../../../components/icon/icon';
import { ContractItems } from '../../../components/user/contract/user.contract.section';
import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SearchCondition } from '../../../components/common/common.search.condition';
import { fetchDriverContract } from '../../../api/contract';

interface DriverContractResponse {
  obtainId: number;
  orderId: number;
  target: string;
  name: string;
  work: string;
}

const UserContract = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [obtainList, setObtainList] = useState<DriverContractResponse[]>([]); // 발주 내역을 저장할 상태
  const [loading, setLoading] = useState(true); // 로딩 상태 관리
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [searchName, setSearchName] = useState<string | null>(null); // name을 저장할 상태 추가

  const handleSearchSubmit = async (
    startDate: Date,
    endDate: Date,
    name?: string,
  ) => {
    // 검색 조건이 제출될 때 처리하는 함수
    const formatDate = (date: Date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    setStartDate(formatDate(startDate));
    setEndDate(formatDate(endDate));
    setSearchName(name || null); // name 상태 저장

    setSearchOpen(false);
  };

  const handleSearchClick = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  // 오늘 부터 일주일 이후 데이터 가져오기
  useEffect(() => {
    const getOrders = async () => {
      try {
        setLoading(true);

        const today = new Date();
        const weekLater = new Date(today);
        weekLater.setDate(today.getDate() + 7);

        const formatDate = (date: Date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const startDateString = startDate || formatDate(today);
        const endDateString = endDate || formatDate(weekLater);

        const data = await fetchDriverContract({
          startDate: startDateString,
          endDate: endDateString,
          name: searchName ?? undefined,
        });

        setObtainList(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    getOrders();
  }, [startDate, endDate, searchName]);

  if (loading) return <p>Loading...</p>;

  return (
    <Container>
      <SearchForm onClick={handleSearchClick}>
        <span>검색</span>
        <div className="icon-box">
          <SearchLineIcon />
        </div>
      </SearchForm>
      <ContractItems items={obtainList} />
      <AnimatePresence initial={false}>
        {searchOpen ? (
          <SearchConditionWrap
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              type: 'fade',
            }}
          >
            <div className="overlay"></div>
            <SearchCondition
              handleSearchClose={handleSearchClose}
              handleSearchSubmit={handleSearchSubmit}
            />
          </SearchConditionWrap>
        ) : null}
      </AnimatePresence>
    </Container>
  );
};

export default UserContract;

// style
const Container = styled.div`
  padding: 0 1.5rem;
`;

const SearchForm = styled.div`
  background-color: ${(props) => props.theme.homeMainBoxBgColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 1.2rem;
  overflow: hidden;
  margin-top: 1.5rem;
  margin-bottom: 1.2rem;
  span {
    padding: 1.3rem;
    font-size: 1.3rem;
    font-weight: 600;
    line-height: 1.3rem;
    color: ${(props) => props.theme.textWhiteColor};
  }
  .icon-box {
    display: flex;
  }
`;

const SearchConditionWrap = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: 'flex';
  justify-content: 'center';
  align-items: 'center';
  cursor: 'pointer';
  width: 100%;
  height: 100%;
  .overlay {
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;
